import { createGlobalStyle } from "styled-components";
// body {
//     background: ${({ theme }) => theme.background};
//     color: ${({ theme }) => theme.color};
//     transition: all 0.50s linear;
//   }
export const GlobalStyles = createGlobalStyle`
  
  .navigation-links,.navigationbar-logo{
    color: ${({ theme }) => theme.color};
  }
  .navigationbar {
    background: ${({ theme }) => theme.backgroundDark};
    .navigation-messaging {
      background: ${({ theme }) => "#3684cc"};
    }
    .navigation-menu {
       &.active {
         background: ${({ theme }) => theme.backgroundLight};
       }
    }
    .fa-times, .fa-bars {
      color: ${({ theme }) => theme.color};
    }
  }
  .dropdown-menu {
    li {
      background: ${({ theme }) => theme.backgroundLight};
      .dropdown-link {
        color: ${({ theme }) => theme.color};
        border-bottom: ${({ theme }) => theme.borderBottom};
      }
    }
  }
  .help-modal {
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.color};
    .modal-content {
      form {
        .subject-input,.help-input {
          background: ${({ theme }) => theme.backgroundLight};
          color: ${({ theme }) => theme.color};
        }
      }
    }
  }
  .buttons {
    .button-cancel {
      background: ${({ theme }) => theme.cancelButton};
    }
  }
  #account-page {
    background: ${({ theme }) => theme.backgroundDark};
  }
  .account-tabs {
    a {
      background: ${({ theme }) => theme.tab};
      color: ${({ theme }) => theme.color};
      &.selected {
      background: ${({ theme }) => theme.tabSelected};
      &:hover:not(.selected) {
        background: ${({ theme }) => theme.tabHover};
      }
      transition: background-color 0.25s ease, color 0.25s ease;
    }
    }
  }
  .edit-profile-modal {
    background: ${({ theme }) => theme.backgroundLight};
    
    .modal-header {
      background: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.color};
    }
    .card-input {
      background: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.color};
    }
  }
  .manage-subscriptions{
    .column-1, .column-2-and-3, .column-4,.my-subscription-text,.add-subscription-text, .not-available-text   {
      color: ${({ theme }) => theme.color};
    }
  }
  .subscriptions-confirmation {
    .title-text, .adding-text, .removing-text, .column-1, .column-2-and-3, .column-4  {
      color: ${({ theme }) => theme.color};
    }
    .go-back-button {
      background: ${({ theme }) => theme.cancelButton};
    }
  }
  .payment {
    .payment-text, .credit-card-on-file  {
      color: ${({ theme }) => theme.color};
    }
  }
  .add-card {
    .pay-with-card-text {
      color: ${({ theme }) => theme.color};
    }
    .card-input, ::-webkit-input-placeholder {
      background: ${({ theme }) => theme.backgroundLight};
      color: ${({ theme }) => theme.color};
    }
  }
  .edit-card {
    .payment-method-text, .last-card-numbers, .expired {
      color: ${({ theme }) => theme.color};
    }
    .card-input, ::-webkit-input-placeholder {
      background: ${({ theme }) => theme.backgroundLight};
      color: ${({ theme }) => theme.color};
    }
  }
  .remove-card-modal {
    background: ${({ theme }) => theme.backgroundLight};
    color: ${({ theme }) => theme.color};
    .modal-header {
      background: ${({ theme }) => theme.background};
    }
  }
  #login-page {
    background: ${({ theme }) => theme.authBackground};
    .card {
      background: ${({ theme }) => theme.cardBackground};
      color: ${({ theme }) => theme.color};
      .input-text, ::-webkit-input-placeholder  {
        background: ${({ theme }) => theme.cardInputBackground};
        color: ${({ theme }) => theme.color};
      }
    }
  }
  #sign-up-page {
    background: ${({ theme }) => theme.authBackground};
    .card {
      background: ${({ theme }) => theme.cardBackground};
      color: ${({ theme }) => theme.color};
      .input-text, ::-webkit-input-placeholder  {
        background: ${({ theme }) => theme.cardInputBackground};
        color: ${({ theme }) => theme.color};
      }
    }
  }
  #reset-page {
    background: ${({ theme }) => theme.authBackground};
    .card {
      background: ${({ theme }) => theme.cardBackground};
      color: ${({ theme }) => theme.color};
      .input-text, ::-webkit-input-placeholder  {
        background: ${({ theme }) => theme.cardInputBackground};
        color: ${({ theme }) => theme.color};
      }
    }
  }
  #pay-with-card-page {
    background: ${({ theme }) => theme.authBackground};
    .card {
      background: ${({ theme }) => theme.cardBackground};
      color: ${({ theme }) => theme.color};
      .input-text, ::-webkit-input-placeholder  {
        background: ${({ theme }) => theme.cardInputBackground};
        color: ${({ theme }) => theme.color};
      }
    }
  }
  #thank-you-page {
    background: ${({ theme }) => theme.authBackground};
    .card {
      background: ${({ theme }) => theme.cardBackground};
      color: ${({ theme }) => theme.color};
      .input-text, ::-webkit-input-placeholder  {
        background: ${({ theme }) => theme.cardInputBackground};
        color: ${({ theme }) => theme.color};
      }
    }
  }

  #dashboard-page {
    background: ${({ theme }) => theme.backgroundDark};
    .refresh-icon,.refresh-text {
      background: ${({ theme }) => theme.refresh};
    }
    .dashboard-tabs-container {
      a {
        background: ${({ theme }) => theme.tab};
        color: ${({ theme }) => theme.color};
        &.selected {
          background: ${({ theme }) => theme.tabSelected};
        }
        &:hover:not(.selected) {
          background: ${({ theme }) => theme.tabHover};
        }
        // transition: background-color 0.25s ease, color 0.25s ease, transform 0.25s ease;
      }
      .add-icon{
        i {
          background: ${({ theme }) => theme.tab};
          &.selected {
            background: ${({ theme }) => theme.tabSelected};
          }
        }
      } 
    }
  }
  .longbow-modal{
    .longbow-modal-header {
      color: ${({ theme }) => theme.color};
      background: ${({ theme }) => theme.background};
    }
    .longbow-modal-content {
      color: ${({ theme }) => theme.color};
      background: ${({ theme }) => theme.backgroundLight};
      .option {
        background: ${({ theme }) => theme.background};
      }
    }
    .longbow-button-cancel {
      background: ${({ theme }) => theme.cancelButton};
    }
  }
  .new-tab-modal {
    .new-tab-modal-header {
      color: ${({ theme }) => theme.color};
      background: ${({ theme }) => theme.background};
    }
    .new-tab-modal-content {
      color: ${({ theme }) => theme.color};
      background: ${({ theme }) => theme.backgroundLight};
      .tab-name, .add-a-ticker, .ticker-list  {
        color: ${({ theme }) => theme.color};
        background: ${({ theme }) => theme.background};
      }
    }
    .search-icon {
      color: ${({ theme }) => theme.cancelButton};
    }
    .new-tab-button-cancel {
      background: ${({ theme }) => theme.cancelButton};
    }
  }
  .dashboard-content {
    background: ${({ theme }) => theme.background};
    .kiss-view-and-ticker {
      color: ${({ theme }) => theme.color};
    }
    .ticker-search {
      input {
        background: ${({ theme }) => theme.background};
        border-color: ${({ theme }) => theme.background};
        &:hover{
          border-color: ${({ theme }) => "#666666"};
          background: ${({ theme }) => theme.backgroundLight};
        }
      }
      
    }
    .info-icon {
      color: ${({ theme }) => theme.color};
    }
    tbody {
      tr{
        td{
          color: ${({ theme }) => theme.color};
          
        }
      }
    }
  }
  .cftc-futures-positioning {
    background: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.color};
  }
  .tooltip {
    text-align: left !important;
    width: 300px;
    &:hover {
      visibility: visible !important;
      opacity: 1 !important;

    }
  }

  `;
